<template>
    <div class="collapse-wrap border rounded-lg p-3" :class="error ? 'border-danger' : ''">
        <div class="collapse-wrap-header d-flex justify-content-between text-pointer" @click="handleToggle">
            <div class="collapse-wrap-header-title text-dark h6 font-weight-bolder my-0 mr-4">{{ title }}</div>
            <div class="collapse-wrap-header-icon text-centered" :class="vShow ? 'up' : ''">
                <i class="bi bi-chevron-down header-icon h6 text-primary"></i>
            </div>
        </div>
        <b-collapse v-model="vShow">
            <slot name="content">
                <div class="collapse-wrap-content border-top mt-2 pt-2">{{ content }}</div>
            </slot>
        </b-collapse>
    </div>
</template>
  
<script>
export default {
    name: 'Collapse',
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '',
        },
        content: {
            type: String,
            default: '',
        },
        error: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            vShow: false,
        }
    },
    computed: {},
    watch: {
        show: {
            handler(newVal, oldVal) {
                this.vShow = newVal
            }
        }
    },
    created() {
        this.vShow = this.show
    },
    methods: {
        handleToggle() {
            this.vShow = !this.vShow
        },
    }
}
</script>
  
<style scoped lang="scss">
.collapse-wrap {
    &-header {
        &-icon {
            transition: all .3s ease;
        }

        &-icon.up {
            transform: rotate(180deg);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/collapse.vue